<div class="form-group">
  @if (showSkip) {
    <div class="question-skip">
      <label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
        <input
          type="checkbox"
          [checked]="skipped"
          [(ngModel)]="skipped"
          (ngModelChange)="onSkipChange()"
          name="add-note-toggle"
          id="skip-driver-details-toggle">
          <span class="custom-toggle__indi"></span>
          <span class="custom-toggle__label">Skip for now</span>
        </label>
      </div>
    }
    <div class="IFD-completed__card mb-10"
      [ngClass]="{'IFD-completed__card--clear': showNoShadow}">
      @if (!uploadedFiles?.length) {
        <div class="IFD-completed__top">
          <h5 [innerHTML]="question.question_prompt"></h5>
          <div class="IFD-completed__right">
            <a href="javascript:void(0);" (click)="onClick()" class="button button--lg button--tertiary">
              Add
              <svg class="icon">
                <use xlink:href="#upload"></use>
              </svg>
            </a>
          </div>
        </div>
      }
      @if (uploadedFiles?.length) {
        <a href="javascript:void(0);" (click)="onClick()" class="IFD-completed__top">
          <h5 [innerHTML]="question.question_prompt"></h5>
          <div class="IFD-completed__right">
            <p class="IFD-completed__count">{{uploadedFiles.length}}</p>
            <svg class="icon">
              <use xlink:href="#chevron-right-small"></use>
            </svg>
          </div>
        </a>
      }
      @if (question.question_hint) {
        <div class="note note--sm note--info">
          <div class="note__icon">
            <svg class="icon">
              <use xlink:href="#info-small"></use>
            </svg>
          </div>
          <div class="note__content" [innerHTML]="question.question_hint">
          </div>
        </div>
      }
      @if (uploadedFiles?.length) {
        <div class="IFD-completed__uploads">
          @for (file of uploadedFiles; track file) {
            <div class="custom-upload custom-upload--media">
              <div class="custom-upload__wrap dz-processing has-thumbnail dz-image-preview dz-success dz-complete">
                <div class="custom-upload__img">
                  <img [src]="file.url" [alt]="file.name">
                </div>
                <div class="custom-upload__icon">
                  <svg class="icon icon--success">
                    <use xlink:href="#complete"></use>
                  </svg>
                </div>
                <div class="custom-upload__filename">
                  <a [href]="file.url" download>{{file.name}}</a>
                </div>
                <div class="custom-upload__control">
                  <svg class="icon icon--success" (click)="removeUploadedFile(file.resource_id)">
                    <use xlink:href="#trash-bin"></use>
                  </svg>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>


